import { useEffect } from 'react';
import { SEO, SITE_URL, buildJsonLd } from '../data/seo';

// Applies the document title, meta description, canonical, Open Graph / Twitter
// tags and the LocalBusiness + Event JSON-LD on mount. See data/seo.ts for why
// this is done at runtime and what to do when the site moves to Webflow.
//
// Renders nothing. Mounted once from App.tsx.

function setMeta(attr: 'name' | 'property', key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}
export function SeoHead() {
  useEffect(() => {
    document.title = SEO.title;
    setMeta('name', 'description', SEO.description);
    setMeta('property', 'og:type', 'website');
    setMeta('property', 'og:site_name', 'Future Astronaut Co.');
    setMeta('property', 'og:title', SEO.title);
    setMeta('property', 'og:description', SEO.description);
    setMeta('property', 'og:url', SITE_URL);
    setMeta('property', 'og:image', SEO.ogImage);
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', SEO.title);
    setMeta('name', 'twitter:description', SEO.description);
    setMeta('name', 'twitter:image', SEO.ogImage);
    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL;
    const ID = 'far-jsonld';
    let script = document.getElementById(ID) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = ID;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(buildJsonLd());
  }, []);
  return null;
}